<template>
  <div>
    <b-row>
      <b-col
        v-if="loading"
        cols="12"
      >
        <loading-card />
      </b-col>
      <template v-else>
        <b-col cols="12">
          <b-row>
            <b-col
              cols="12"
              md="7"
            >
              <b-row>
                <b-col cols="12">
                  <default-card
                    title="Genel Toplam"
                    sub-title="Ay / Yıl"
                    :value="complaints.grandTotals.mtd"
                    :totals="complaints.grandTotals.ytd"
                    icon="InfoIcon"
                    color="info"
                  />
                </b-col>
                <b-col
                  v-for="item in complaints.data"
                  :key="item.id"
                  cols="12"
                  md="6"
                >
                  <default-card
                    :title="item.title"
                    sub-title="Ay / Yıl"
                    :value="item.mtd"
                    :totals="item.ytd"
                    icon="InfoIcon"
                    color="info"
                  />
                </b-col>
              </b-row>
            </b-col>
            <b-col
              cols="12"
              md="5"
            >
              <pie-charts
                v-if="complaints.grandTotals.chartData.monthly.series.length"
                :series-data="complaints.grandTotals.chartData.monthly.series"
                :categories-data="complaints.grandTotals.chartData.monthly.labels"
                chart-title="Markalar"
                chart-sub-title="Aylık"
                chart-type="donut"
              />
              <pie-charts
                v-if="complaints.grandTotals.chartData.yearly.series.length"
                :series-data="complaints.grandTotals.chartData.yearly.series"
                :categories-data="complaints.grandTotals.chartData.yearly.labels"
                chart-title="Markalar"
                chart-sub-title="Yıllık"
                chart-type="donut"
              />
            </b-col>
          </b-row>
        </b-col>
      </template>
    </b-row>
  </div>
</template>
<script>
import { BRow, BCol } from 'bootstrap-vue'
import DefaultCard from '@/layouts/components/ReportCards/DefaultCard.vue'
import LoadingCard from '@/layouts/components/Loading.vue'
import PieCharts from '@/layouts/components/ReportCharts/PieCharts.vue'

export default {
  name: 'Services',
  components: {
    PieCharts,
    LoadingCard,
    BRow,
    BCol,
    DefaultCard,
  },
  computed: {
    loading() {
      return this.$store.getters['crmComplaintsReports/loading']
    },
    complaints() {
      return this.$store.getters['crmComplaintsReports/complaints']
    },
    complaintParams() {
      return this.$store.getters['crmComplaintsReports/complaintParams']
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.complaintParams.type = 'services'
      this.$store.dispatch('crmComplaintsReports/getData', this.complaintParams)
    },
  },
}
</script>
